import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TitleBar from "components/TitleBar";
import PBGTrackerList from "view/financialBGTracker/PBGTrackerList";

const BankWiseExposureByCount = ({ data, isLoading, isError }) => {

    const colorPlate = ["#D81B60", "#FF9800", "#9C27B0"];


    const statusConfig = [
        {
            key: "abgCount",
            color: colorPlate[0],
            label: "ABG"
        },
        {
            key: "pbgCount",
            color: colorPlate[1],
            label: "PBG"
        },
        {
            key: "rbgCount",
            color: colorPlate[2],
            label: "RBG"
        },
    ];


    const categories = data.map((item) => item.bankName);

    // Dynamic series
    const series = statusConfig.map((status) => ({
        name: status.label,
        color: status.color,
        data: data.map((item) => ({
            y: item[status.key] || null,
            bankName: item.bankName,
            guaranteeType: status.key,
        })),
    }));


    const options = {
        chart: {
            type: "column",
            height: 400,
        },

        title: {
            text: "",
        },

        xAxis: {
            categories,
        },

        yAxis: {
            min: 0,
            title: {
                text: "Count",
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontSize: "10px",
                    fontWeight: "500",
                    color: "#374151",
                },
            },
        },

        tooltip: {
            headerFormat: "<b>{point.category}</b><br/>",
            pointFormat:
                "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
        },

        plotOptions: {
            column: {
                stacking: "normal",
                borderRadius: 4,
                borderWidth: 0,
                dataLabels: {
                    enabled: false,
                },
                // point: {
                //     events: {
                //         click: function () {

                //             const category = this.category;
                //             const status = this.series.name;
                //             console.log({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //             handleCategoryClick({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //         },
                //     },
                // },
            },
        },

        series,

        credits: {
            enabled: false,
        },
    };

    return (
        <Box>
            <TitleBar
                title={"Bank Wise Exposure"}
                description={"Bank-wise distribution of active bank guarantees based on count"}
            />

            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                }}
            >

                {/* Right Side Chart */}
                <Grid size={12}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default BankWiseExposureByCount;